<template>
  <transition name="license-dialog-fade">
    <div v-if="visible" class="license-dialog-mask" @click.self="handleClose">
      <div class="panel" :class="hasImageList ? 'panel-list' : 'panel-single'" role="dialog" aria-modal="true"
        :aria-label="imageAlt || title || '图片弹窗'">
        <button type="button" class="close" aria-label="关闭证照弹窗" @click="handleClose">
          <img src="../../../assets/home-confirm/dialogs/contact-close.svg" alt="" class="close-icon" />
        </button>

        <p v-if="title" class="title">{{ title }}</p>

        <div class="content" :class="hasImageList ? 'content-list' : 'content-single'">
          <template v-if="hasImageList">
            <div v-for="(item, index) in normalizedImageList" :key="`${item.imageSrc}-${index}`" class="image-card">
              <el-image :src="item.imageSrc" :alt="item.imageAlt" class="image image-list" fit="fill"
                :preview-src-list="[item.imageSrc]" :z-index="2000" />
            </div>
          </template>

          <div v-else-if="singleImageSrc" class="single-image-wrap">
            <el-image :src="singleImageSrc" :alt="imageAlt" class="image image-single" fit="contain"
              :preview-src-list="[singleImageSrc]" :z-index="2000" />
          </div>

          <div v-else class="empty">暂无图片</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LicenseDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    imageAlt: {
      type: String,
      default: "营业执照",
    },
    imageSrc: {
      type: String,
      default: "",
    },
    imageList: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    hasImageList() {
      return this.normalizedImageList.length > 0;
    },
    singleImageSrc() {
      return String(this.imageSrc || "").trim();
    },
    normalizedImageList() {
      return this.imageList
        .map((item) => ({
          imageSrc: item && item.img ? String(item.img).trim() : "",
          imageAlt: item && item.title ? item.title : this.imageAlt,
        }))
        .filter((item) => item.imageSrc);
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.license-dialog-mask {
  position: fixed;
  inset: 0;
  z-index: 1997;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 66.67vw;
  max-width: calc(100vw - 48px);
  max-height: calc(100vh - 48px);
  padding: 44px 48px 48px;
  box-sizing: border-box;
  overflow: hidden;
  background: #ffffff;
}

.panel-single {
  height: min(820px, calc(100vh - 48px));
}

.title {
  margin: 0 0 24px;
  color: #000000;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}

.content {
  flex: 1;
  min-height: 0;
  width: 100%;
}

.content-single {
  display: flex;
}

.single-image-wrap {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  font-size: 18px;
  line-height: 24px;
}

.content-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: auto;
  column-gap: 48px;
  row-gap: 48px;
  justify-content: center;
  align-content: start;
  overflow-y: auto;
  overflow-x: hidden;
}

.image-card {
  width: 100%;
  aspect-ratio: 210 / 297;
}

.close {
  position: absolute;
  top: 15px;
  right: 17px;
  z-index: 2;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.close-icon {
  width: 14px;
  height: 14px;
}

.image {
  display: flex;
  width: 100%;
  height: 100%;
  cursor: zoom-in;
}

.image-list {
  width: 100%;
  height: 100%;
}

.image-single {
  width: 100%;
  height: 100%;
  max-height: none;
}

.license-dialog-fade-enter-active,
.license-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.license-dialog-fade-enter-active .panel,
.license-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.license-dialog-fade-enter,
.license-dialog-fade-enter-from,
.license-dialog-fade-leave-to {
  opacity: 0;
}

.license-dialog-fade-enter .panel,
.license-dialog-fade-enter-from .panel,
.license-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
<style scoped src="./LicenseDialog.mobile.css"></style>
